/** Runtime validators for manual tour substeps (registered by form pages). */

const registry = new Map();

export function tourValidatorKey(stepId, subId) {
  return `${stepId}:${subId}`;
}

/** @returns {() => boolean | { ok: boolean, message?: string }} */
export function registerTourValidator(stepId, subId, fn) {
  const key = tourValidatorKey(stepId, subId);
  registry.set(key, fn);
  return () => {
    if (registry.get(key) === fn) registry.delete(key);
  };
}

export function validateTourSubstep(stepId, subId) {
  const fn = registry.get(tourValidatorKey(stepId, subId));
  if (!fn) return { ok: true };
  try {
    const result = fn();
    if (result === true) return { ok: true };
    if (result === false) {
      return { ok: false, message: "Заполните поле, чтобы продолжить" };
    }
    if (result && typeof result === "object") {
      return {
        ok: Boolean(result.ok),
        message: result.message || "Заполните поле, чтобы продолжить",
      };
    }
    return { ok: Boolean(result) };
  } catch {
    return { ok: true };
  }
}

export function clearTourValidators(stepId) {
  for (const key of registry.keys()) {
    if (key.startsWith(`${stepId}:`)) registry.delete(key);
  }
}
